<div class="supp-selector-div">
  <input #input (focus)="selectText()" [(ngModel)]="value"
         [disabled]="params?.data?._tags?.includes('disabled') && !params?.context?.isStockManager"
         class="input"/>

  <div (click)="toggleDropdown()" class="toggle-button"> Options
    <app-icon-chevron-down></app-icon-chevron-down>
  </div>

  @if (showOptions) {
    <div #optionsList [ngClass]="{'options-list': true, 'above': displayAbove}">
      <div class="scrollable-options">
        @for (option of onHoldTypes | keyvalue; track option.key) {
          <div>
            @if (option.value !== 'NA') {
              <label>
                <input
                  (change)="toggleSelection(option.key)"
                  [checked]="selectedValues.includes(option.value)"
                  [disabled]="params.data?._tags?.includes('disabled') && !params.context?.isStockManager"
                  type="checkbox"/>
                {{ option.value }}
              </label>
            }
          </div>
        }
      </div>
      <button (click)="onConfirmButtonClick()" class="buttons" type="button">OK</button>
      <button (click)="onCancelButtonClick()" class="buttons" type="button">Cancel</button>
    </div>
  }

  <!-- Undo changes button icon -->
  @if (params.data.originalValue[params.colDef.field].value !== selectedValues) {
    <app-display-icon
      (click)="onUndoChangesClick()"
      [icon]="icons.backSpaceOutline"
      class="backspace">
    </app-display-icon>
  }
</div>
